import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// withCredentials makes the browser send the httpOnly auth cookie automatically.
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;
